import {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
  type Analytics,
} from "firebase/analytics";
import type { IAnalyticsProvider } from "@repo/analytics";
import { getFirebaseApp } from "../lib/firebase";

export class FirebaseWebProvider implements IAnalyticsProvider {
  public name = "FirebaseWeb";
  private analytics: Analytics | null = null;

  async init(): Promise<void> {
    try {
      const app = getFirebaseApp();
      this.analytics = getAnalytics(app);
    } catch (error) {
      console.error("[FirebaseWebProvider] Initialization failed:", error);
    }
  }

  trackEvent(eventName: string, payload: Record<string, any>): void {
    if (!this.analytics) return;
    logEvent(this.analytics, eventName, payload);
  }

  identifyUser(userId: string, traits?: Record<string, any>): void {
    if (!this.analytics) return;
    setUserId(this.analytics, userId);
    if (traits) {
      setUserProperties(this.analytics, traits);
    }
  }

  setUserProperties(properties: Record<string, any>): void {
    if (!this.analytics) return;
    setUserProperties(this.analytics, properties);
  }

  trackScreen(screenName: string, properties?: Record<string, any>): void {
    if (!this.analytics) return;
    logEvent(this.analytics, "screen_view" as any, {
      firebase_screen: screenName,
      ...properties,
    });
  }

  resetUser(): void {
    if (!this.analytics) return;
    setUserId(this.analytics, null);
  }
}
